module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/room-df6a70fc6a86f3de9ac2b28a67905363.webp";